import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import $ from "jquery";
import axios from "axios";
import ReqService from '../../request/service';
import Waiter from './../../assets/gif/blueCircle.gif';
import CopySound from './../../assets/sound/beep07a.wav';
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from '../../constants';
import {stringToHex} from "../forms/validator";
const GlobalStyles = createGlobalStyle`

.img-md img {
	display:inline-block;
	position:relative;
	height:96px;
	max-height:96px;
	width:auto;
	border:2px solid #efefef;
	border-radius:4px;
}
`;

const JComponent = (props) => { 
	const [disabled,setDisabled]=useState(false);
	const [rows,setRows]=useState([]);
	const [fetchOnReq,setFecthOnReq]=useState(false);
	const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
  	const [fundingAgencyList,setFundingAgencyList]=useState([]);
  	const [userAgencyList,setUserAgencyList]=useState([]);
	const [showImageBox,setShowImageBox]=useState(false);
	const [showQRBox,setShowQRBox]=useState(false);
	const [selectedImages,setSelectedImages]=useState([]);
	const [selectedQRImage,setSelectedQRImage]=useState("");
	let _TX=1;
	useEffect(()=>{ 
		console.log(window.location);
		let params=window.location.search;
		params=(params!=null && params!=undefined)?params.substring(1):"";

		console.log(params);
		if(_TX==1){ _TX++;
		loadAssetCategoryList();
		loadImplAgencyList();
		loadUserAgencyList();
		let _rows=[];
		setRows([]);
		
		
			
			let _d={
					token:localStorage.getItem("_xoxex"),
					assetId:params,
				};
			let idata=stringToHex(JSON.stringify(_d));	
			setFecthOnReq(true);	
			var config = {
				method: 'post',
				url: API_CORE_SERVER+"/api/document/get-document.php",
				headers: { 
					'Content-Type': 'application/x-www-form-urlencoded',
					//'Content-Type': 'application/json', 
				},
				data:"i="+idata
			  };
			  axios(config).then(response=>{
				if(response.status===200 && response.data){
					let data=response.data;
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						for(let i=0;i<records.length;i++){
							let assetId=records[i].assetId;
							try{
									let rec=JSON.parse(records[i].data);
									//console.log(rec);
									_rows.push({ 
										assetId:assetId,
										assetType:rec.assetInfo.assetType,
										assetName:rec.assetInfo.assetName,
										implementAgency:rec.assetInfo.implementAgency,
										fundingAgency:rec.assetInfo.fundingAgency,
										userAgency:rec.assetInfo.userAgency,
										assetDescription:rec.assetInfo.assetDescription,
										panchayat:rec.assetInfo.panchayat,
										address:rec.assetInfo.address,
										village:rec.assetInfo.village,
										block:rec.assetInfo.block,
										beneficiary:rec.assetInfo.beneficiary,
										agrCost:rec.assetDetail.agrCost,
										agrDate:rec.assetDetail.agrDate,
										estCost:rec.assetDetail.estCost,
										estWorkStartDate:rec.assetDetail.estWorkStartDate,
										estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
										workStartDate:rec.assetDetail.workStartDate,
										workFinishDate:rec.assetDetail.workFinishDate,
										workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
										workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
										lat:rec.assetDetail.lat,
										lng:rec.assetDetail.lng,
										name:rec.contractorInfo.name,
										photos:rec.assetDetail.photos,
										contractor:rec.contractorInfo
									});
								}catch(e){
									console.log("exp:assetId:"+assetId);
								}
						}
					}
				}
				
				setFecthOnReq(false);
			});
			setRows(_rows);
			
		}
		
	},[]);
	
	const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadFundingAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_funding_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setFundingAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	const copyi=(e)=>{
		//window.document.getElementById('audiox').play();
		//console.log(e.target.id);
		window.navigator.clipboard.writeText(e.target.getAttribute("a"));
	}
	
	return (
        <>
		<GlobalStyles />
		<div className='row'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Project Details</h5>
		<div className='col-12'>
			<div className='card'>
			<div className="card-body" style={{overflowX:"scroll"}}>
			{fetchOnReq===true && 
				<>
					<img src={Waiter} className='waiter-md'/>
				</>
			}
			{(fetchOnReq===false && rows.length>=1) && 
                <>
				{ rows && rows.map((item,i)=>{
								return(
									i===0?
                                    <>
									<div className="d-flex">
										<div className="flex-grow-1">
											<div className="img-md">
													{
													item && item.photos && item.photos.split(",").map((ph,iph)=>{
													return(iph>0?
															
																<img src={API_CORE_SERVER+"/_apithumbnail/"+ph}
																data={ph}
																className="cursor-pointer"
																onClick={e=>{
																	
																	setSelectedImages([e.target.getAttribute("data")]);
																	setShowImageBox(true);
																}}
																/>
															
															:<></>
														)
													})}
											</div>
										</div>		
										<div className="cursor-pointer img-md">
												<img 
												src={"https://gramsampati.in/api/document/get-qr-code.php?ai="+item.assetId} 
												onClick={e=>{
																
													setSelectedQRImage(e.target.getAttribute("src"));
													setShowQRBox(true);
												}}
												/>
										</div>
									</div>
									<div className='d-flex mt-4'>&nbsp;</div>
									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Implementing Agency</div>
											<div className='formValue'>{getImplAgencyById(item.implementAgency)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Funding Agency</div>
											<div className='formValue'>{item.fundingAgency}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>User Agency</div>
											<div className='formValue'>{getUserAgencyById(item.userAgency)}</div>
										</div>		
									</div>
                                    <div className='formDiv'>
                                        <div className='formLabel'>Asset Name</div>
                                        <div className='formValue'>{item.assetName}</div>
                                    </div>
                                    <div className='formDiv'>
                                        <div className='formLabel'>Description</div>
                                        <div className='formValue'>{item.assetDescription}</div>
                                    </div>
                                    <div className='formDiv'>
                                        <div className='formLabel'>Asset Type</div>
                                        <div className='formValue'>{getAssetType(item.assetType)}</div>
                                    </div>

                                    <div className='formDiv'>
                                        <div className='formLabel'>Address</div>
                                        <div className='formValue'>{item.address}</div>
                                    </div>

									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>village</div>
											<div className='formValue'>{item.village}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Panchayat</div>
											<div className='formValue'>{item.panchayat}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>block</div>
											<div className='formValue'>{item.block}</div>
										</div>
									</div>

									<div className='formDiv'>
                                        <div className='formLabel'>Beneficiary</div>
                                        <div className='formValue'>{item.beneficiary}</div>
                                    </div>

									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Agreement cost</div>
											<div className='formValue'>{(item.agrCost)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Agreement date</div>
											<div className='formValue'>{(item.agrDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Estimeted cost</div>
											<div className='formValue'>{(item.estCost)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Estimeted work start date</div>
											<div className='formValue'>{(item.estWorkStartDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Estimeted Work Finsh by days</div>
											<div className='formValue'>{(item.estWorkCompleteByDays)}</div>
										</div>
									</div>	

									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Work start date</div>
											<div className='formValue'>{(item.workStartDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Work finsh date</div>
											<div className='formValue'>{(item.workFinishDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Work status</div>
											<div className='formValue'>{(item.workStatus)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Work progress</div>
											<div className='formValue'>{(item.workProgress)}%</div>
										</div>
										
									</div>		
									
									<div className="card bg-light">
										<div className="card-body">
											<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Contractor Details</h5>
											<div className="d-flex">
												<div className='formDiv'>
													<div className='formLabel'>Contractor Name</div>
													<div className='formValue'>{(item.contractor.name)}</div>
														
												</div>	
												<div className='formDiv'>
													<div className='formLabel'>Contractor Registration No</div>
													<div className='formValue'>{(item.contractor.regNo)}</div>
												</div>
												<div className='formDiv'>
													<div className='formLabel'>Contact No</div>
													<div className='formValue'>{(item.contractor.contactNo)}</div>
												</div>
											</div>	
											<div className='formDiv'>
													<div className='formLabel'>Address</div>
													<div className='formValue'>{(item.contractor.address)}</div>
											</div>		
											<div className="d-flex">
												<div className='formDiv'>
													<div className='formLabel'>District</div>
													<div className='formValue'>{(item.contractor.district)}</div>
												</div>
												<div className='formDiv'>
													<div className='formLabel'>State</div>
													<div className='formValue'>{(item.contractor.state)}</div>
												</div>
												
											</div>
										</div>
									</div>

                                    </>
                                    :<></>	
								)
					})
					}
				</>	
			}
			</div>	
			</div>
		</div>
		
	</div>	

	{showImageBox===true &&
	<>
	<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
		<div className="d-flex justify-content-end p-4">
			<div className="cursor-pointer text-dark" onClick={()=>{
				setShowImageBox(false);
			}}>Close</div>
		</div>
		<div className='d-flex vh-100 align-items-center'>
			<div className='row vw-100' style={{marginTop:'-8rem'}}>
			<div className='col-md-5 mx-auto border rounded-2 p-4'>
				<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
				<div className='text-center text-black fs-6'  >
				<img src={API_CORE_SERVER+"/_apistorage/"+selectedImages[0]} style={{maxWidth:'450px',maxHeight:'450px'}}  />
				</div>
				<div className='pt-4 text-end' >
					<button className='btn btn-secondary' onClick={()=>{
					setShowImageBox(false);
					}}>Close</button>
				</div>
			</div>
			</div>
		</div>
	</div>
	</>
	}
	
	{showQRBox===true &&
		<>
		<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setShowQRBox(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row vw-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
					<div className='text-center text-black fs-6'  >
					<img src={selectedQRImage} style={{maxWidth:'450px',maxHeight:'450px'}}  />
					</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary' onClick={()=>{
						setShowQRBox(false);
						}}>Close</button>
					</div>
				</div>
				</div>
			</div>
		</div>
		</>
	}		

	</>
    )
}

export default JComponent;